import React, { useState } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { Button } from "antd"; // Using Ant Design Input for better UI consistency
import Select from "react-select";
import { Delete, PlusCircle, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import ImageUploader from "Components/UI/ImageUploder";
import ImageCropper from "Components/UI/Image/ImageCropper";
const CourseAndCertificate = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "certificationsDetails",
  });

  const experienceDetails = watch("certificationsDetails") || [];

  const addExperienceRow = () => {
    const newExperience = {
      code: 0,
      companyCode: watch("companyCode"),
      employeeCode: watch("employeeCode"),
      courseName: "",
      abbreviation: "",
      certificateNumber: "",
      issueDate: "",
      expiryDate: "",
      documentImage: "",
      documentImageBack: "",
      remark: "",
      isDefault: true,
      isActive: true,
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: watch("modifyDate"),
    };

    setValue("certificationsDetails", [...experienceDetails, newExperience]);
  };

  const removeExperience = (index) => {
    const updatedExperience = experienceDetails.filter((_, i) => i !== index);
    setValue("certificationsDetails", updatedExperience);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm "
          type="button"
          onClick={addExperienceRow}
        >
          <PlusCircle className="me-2" />
          Add Row
        </button>
      </div>
      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Course Name</th>
              <th>Abbreviation</th>
              <th>Certificate Number</th>
              <th>Issue Date</th>
              <th>Expiry Date</th>
              <th>Front Image</th>
              <th>Back Image</th>
              <th>remark</th>
            </tr>
          </thead>

          <tbody>
            {experienceDetails.map((data, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Button type="danger" onClick={() => remove(index)}>
                      <Trash2 />
                    </Button>
                  </td>
                  <td>
                    <Input
                      name={`certificationsDetails[${index}].courseName`}
                      type="text"
                      placeholder="Course Name"
                      className={`form-control ${
                        errors?.certificationsDetails?.[index]?.courseName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`certificationsDetails[${index}].abbreviation`}
                      type="text"
                      placeholder="Abbreviation"
                      className={`form-control ${
                        errors?.certificationsDetails?.[index]?.abbreviation
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`certificationsDetails[${index}].certificateNumber`}
                      type="text"
                      placeholder="Certificate Number"
                      className={`form-control ${
                        errors?.certificationsDetails?.[index]
                          ?.certificateNumber
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`certificationsDetails[${index}].issueDate`}
                      type="date"
                      placeholder="Issue Date"
                      className={`form-control ${
                        errors?.certificationsDetails?.[index]?.issueDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`certificationsDetails[${index}].issueDate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`certificationsDetails[${index}].expiryDate`}
                      type="date"
                      placeholder="Expiry Date"
                      className={`form-control ${
                        errors?.certificationsDetails?.[index]?.expiryDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`certificationsDetails[${index}].expiryDate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <ImageCropper
                      base64Value={watch(
                        `certificationsDetails[${index}].documentImage`
                      )}
                      setBase64Value={(value) =>
                        setValue(
                          `certificationsDetails[${index}].documentImage`,
                          value
                        )
                      }
                      id={`documentImage-${index}`}
                    />
                  </td>
                  <td>
                    <ImageCropper
                      base64Value={watch(
                        `certificationsDetails[${index}].documentImageBack`
                      )}
                      setBase64Value={(value) =>
                        setValue(
                          `certificationsDetails[${index}].documentImageBack`,
                          value
                        )
                      }
                      id={`documentImageBack-${index}`}
                    />
                  </td>

                  <td>
                    <Input
                      name={`certificationsDetails[${index}].remark`}
                      type="text"
                      placeholder="remark"
                      className={`form-control ${
                        errors?.certificationsDetails?.[index]?.remark
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CourseAndCertificate;
